export default __webpack_public_path__ + "assets/icon-payments.f6120d63.webp";